import {
  FETCH_PM_IWO_LIST_REQUEST,
  FETCH_PM_IWO_LIST_SUCCESS,
  FETCH_PM_IWO_LIST_FAILURE,
  INSERT_PM_FRAME_REQUEST,
  INSERT_PM_FRAME_SUCCESS,
  INSERT_PM_FRAME_FAILURE,
  FETCH_PM_FRAME_LIST_REQUEST,
  FETCH_PM_FRAME_LIST_SUCCESS,
  FETCH_PM_FRAME_LIST_FAILURE,
  INSERT_PM_DAILY_REMARK_REQUEST,
  INSERT_PM_DAILY_REMARK_SUCCESS,
  INSERT_PM_DAILY_REMARK_FAILURE,
  UPDATE_PM_COMPLETION_REQUEST,
  UPDATE_PM_COMPLETION_SUCCESS,
  UPDATE_PM_COMPLETION_FAILURE,
  UPDATE_PM_FRAME_REQUEST,
  UPDATE_PM_FRAME_SUCCESS,
  UPDATE_PM_FRAME_FAILURE,
  FETCH_PM_DELAY_REASONS_REQUEST,
  FETCH_PM_DELAY_REASONS_SUCCESS,
  FETCH_PM_DELAY_REASONS_FAILURE,
  DELETE_PM_FRAME_REQUEST,
  DELETE_PM_FRAME_SUCCESS,
  DELETE_PM_FRAME_FAILURE,
  FETCH_PM_IWO_FRAMES_REQUEST,
  FETCH_PM_IWO_FRAMES_SUCCESS,
  FETCH_PM_IWO_FRAMES_FAILURE,
  FETCH_PM_PART_WEIGHTS_REQUEST,
  FETCH_PM_PART_WEIGHTS_SUCCESS,
  FETCH_PM_PART_WEIGHTS_FAILURE,
  SAVE_PM_PART_WEIGHTS_REQUEST,
  SAVE_PM_PART_WEIGHTS_SUCCESS,
  SAVE_PM_PART_WEIGHTS_FAILURE,
  FETCH_PM_FRAMES_REQUEST,
  FETCH_PM_FRAMES_SUCCESS,
  FETCH_PM_FRAMES_FAILURE,
  FETCH_PM_DAILY_REMARKS_REQUEST,
  FETCH_PM_DAILY_REMARKS_SUCCESS,
  FETCH_PM_DAILY_REMARKS_FAILURE,
} from "../constants/ProductionMonitorConstants";

const initialState = {
  iwoList: [],
  iwoListLoading: false,
  iwoListError: null,

  insertLoading: false,
  insertError: null,
  insertResult: null,

  frameList: [],
  frameListLoading: false,
  frameListError: null,

  remarkLoading: false,
  remarkError: null,

  completionLoading: false,
  completionError: null,

  frameUpdateLoading: false,
  frameUpdateError: null,

  cdlDelayReasons: [],
  dtsDelayReasons: [],
  delayReasonsLoading: false,
  delayReasonsError: null,

  frameDeleteLoading: false,
  frameDeleteError: null,

  // frames of the IWOs chosen in Production (Quick Select by Additional)
  iwoFrames: [],
  iwoFramesLoading: false,
  iwoFramesError: null,

  // part weights of the IWO chosen in Insert Frames
  partWeightsIwoNo: null,
  partWeights: [],
  partWeightsLoading: false,
  partWeightsError: null,
  partWeightsSaving: false,
  partWeightsSaveError: null,

  // Remark History
  frames: [],
  framesLoading: false,
  framesError: null,
  dailyRemarksKey: null,
  dailyRemarks: [],
  dailyRemarksLoading: false,
  dailyRemarksError: null,
};

export const ProductionMonitorReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PM_IWO_LIST_REQUEST:
      return { ...state, iwoListLoading: true, iwoListError: null };
    case FETCH_PM_IWO_LIST_SUCCESS:
      return { ...state, iwoList: action.payload || [], iwoListLoading: false };
    case FETCH_PM_IWO_LIST_FAILURE:
      return { ...state, iwoList: [], iwoListError: action.payload, iwoListLoading: false };

    case INSERT_PM_FRAME_REQUEST:
      return { ...state, insertLoading: true, insertError: null, insertResult: null };
    case INSERT_PM_FRAME_SUCCESS:
      return { ...state, insertLoading: false, insertResult: action.payload };
    case INSERT_PM_FRAME_FAILURE:
      return { ...state, insertLoading: false, insertError: action.payload };

    case FETCH_PM_FRAME_LIST_REQUEST:
      return { ...state, frameListLoading: true, frameListError: null };
    case FETCH_PM_FRAME_LIST_SUCCESS:
      return { ...state, frameList: action.payload || [], frameListLoading: false };
    case FETCH_PM_FRAME_LIST_FAILURE:
      return { ...state, frameList: [], frameListError: action.payload, frameListLoading: false };

    case INSERT_PM_DAILY_REMARK_REQUEST:
      return { ...state, remarkLoading: true, remarkError: null };
    case INSERT_PM_DAILY_REMARK_SUCCESS:
      return { ...state, remarkLoading: false };
    case INSERT_PM_DAILY_REMARK_FAILURE:
      return { ...state, remarkLoading: false, remarkError: action.payload };

    case UPDATE_PM_COMPLETION_REQUEST:
      return { ...state, completionLoading: true, completionError: null };
    case UPDATE_PM_COMPLETION_SUCCESS:
      return { ...state, completionLoading: false };
    case UPDATE_PM_COMPLETION_FAILURE:
      return { ...state, completionLoading: false, completionError: action.payload };

    case UPDATE_PM_FRAME_REQUEST:
      return { ...state, frameUpdateLoading: true, frameUpdateError: null };
    case UPDATE_PM_FRAME_SUCCESS:
      return { ...state, frameUpdateLoading: false };
    case UPDATE_PM_FRAME_FAILURE:
      return { ...state, frameUpdateLoading: false, frameUpdateError: action.payload };

    case FETCH_PM_DELAY_REASONS_REQUEST:
      return { ...state, delayReasonsLoading: true, delayReasonsError: null };
    case FETCH_PM_DELAY_REASONS_SUCCESS:
      return {
        ...state,
        cdlDelayReasons: action.payload?.CdlDelayReasons || [],
        dtsDelayReasons: action.payload?.DtsDelayReasons || [],
        delayReasonsLoading: false,
      };
    case FETCH_PM_DELAY_REASONS_FAILURE:
      return { ...state, delayReasonsLoading: false, delayReasonsError: action.payload };

    case DELETE_PM_FRAME_REQUEST:
      return { ...state, frameDeleteLoading: true, frameDeleteError: null };
    case DELETE_PM_FRAME_SUCCESS:
      return {
        ...state,
        frameDeleteLoading: false,
        // remove it from the list straight away
        frameList: state.frameList.filter((f) => String(f.FrameId) !== String(action.payload)),
      };
    case DELETE_PM_FRAME_FAILURE:
      return { ...state, frameDeleteLoading: false, frameDeleteError: action.payload };

    case FETCH_PM_IWO_FRAMES_REQUEST:
      return { ...state, iwoFrames: [], iwoFramesLoading: true, iwoFramesError: null };
    case FETCH_PM_IWO_FRAMES_SUCCESS:
      return { ...state, iwoFrames: action.payload || [], iwoFramesLoading: false };
    case FETCH_PM_IWO_FRAMES_FAILURE:
      return { ...state, iwoFrames: [], iwoFramesLoading: false, iwoFramesError: action.payload };

    case FETCH_PM_PART_WEIGHTS_REQUEST:
      return { ...state, partWeightsIwoNo: action.payload, partWeights: [], partWeightsLoading: true, partWeightsError: null };
    case FETCH_PM_PART_WEIGHTS_SUCCESS:
      // ignore an old answer if the IWO was changed meanwhile
      if (action.payload.iwoNo !== state.partWeightsIwoNo) return state;
      return { ...state, partWeights: action.payload.parts, partWeightsLoading: false };
    case FETCH_PM_PART_WEIGHTS_FAILURE:
      return { ...state, partWeights: [], partWeightsLoading: false, partWeightsError: action.payload };

    case SAVE_PM_PART_WEIGHTS_REQUEST:
      return { ...state, partWeightsSaving: true, partWeightsSaveError: null };
    case SAVE_PM_PART_WEIGHTS_SUCCESS:
      return { ...state, partWeightsSaving: false };
    case SAVE_PM_PART_WEIGHTS_FAILURE:
      return { ...state, partWeightsSaving: false, partWeightsSaveError: action.payload };

    case FETCH_PM_FRAMES_REQUEST:
      return { ...state, framesLoading: true, framesError: null };
    case FETCH_PM_FRAMES_SUCCESS:
      return { ...state, frames: action.payload || [], framesLoading: false };
    case FETCH_PM_FRAMES_FAILURE:
      return { ...state, frames: [], framesLoading: false, framesError: action.payload };

    case FETCH_PM_DAILY_REMARKS_REQUEST:
      return { ...state, dailyRemarksKey: action.payload, dailyRemarks: [], dailyRemarksLoading: true, dailyRemarksError: null };
    case FETCH_PM_DAILY_REMARKS_SUCCESS:
      if (action.payload.key !== state.dailyRemarksKey) return state; // filters changed meanwhile
      return { ...state, dailyRemarks: action.payload.remarks, dailyRemarksLoading: false };
    case FETCH_PM_DAILY_REMARKS_FAILURE:
      if (action.payload.key !== state.dailyRemarksKey) return state;
      return { ...state, dailyRemarks: [], dailyRemarksLoading: false, dailyRemarksError: action.payload.message };

    default:
      return state;
  }
};